import React, { useState } from 'react'
import { View, ScrollView, TouchableOpacity, Linking, } from 'react-native'
import { useSelector } from 'react-redux'
import { IStores } from '../../state/store'
import { ReactComponent as ChevronDownIcon, } from '../../assets/icons/chevron-down-filled.svg'
import Text from '../text'
import Block from './Block'
import Input from '../input'
import Button from '../button'
import { email } from '../../utils/constants'

const faqs = [
  {
    question: 'What is Streetpass?',
    answer: 'Streetpass is an app that matches you with people you pass in the street.',
    tags: 'app match street',
  },
  {
    question: 'How does Streetpass work?',
    answer: 'Streetpass works by using your current location to search for other users nearby. You will only streetpass with people within short proximity.',
    tags: 'it works',
  },
  {
    question: 'Does Streetpass need to be open to get matches?',
    answer: 'No! If you grant the app access to your location always, Streetpass will match you with others even while the app is in the background or your phone is asleep.',
    tags: 'my phone on awake',
  },
  {
    question: 'Why does Streetpass request my location?',
    answer: 'Streetpass needs your location to find other nearby users. This also helps us determine that you\'re not a bot, so we can safely match you with others. Your always on location is requested so that Streetpass can work in the background.',
    tags: 'is always on',
  },
  {
    question: 'Is my live location shared with others?',
    answer: 'No! Your live location is never shared with anyone. If you match with someone, they may see the approximate location where you streetpassed — but only if you\'ve enabled this option in your privacy settings.',
    tags: 'does it show where me really am place',
  },
  {
    question: 'Does Streetpass work indoors?',
    answer: 'Yes! Streetpass works wherever you have a wifi or cellular connection.',
    tags: 'it only works outdoors inside outside',
  },
  {
    question: 'Does Streetpass work in other countries?',
    answer: 'Yes! Streetpass works globally, so you can connect with people no matter where you travel.',
    tags: 'it only works out of country abroad outside inside',
  },
  {
    question: 'Why didn\'t I streetpass with someone when we passed each other?',
    answer: 'A streetpass could have failed for several reasons. Both users must have a good network connection, have streetpassing enabled, meet each other\'s filters, and not be in vicinity of a safe zone.',
    tags: 'did not match some one other user',
  },
  {
    question: 'Why didn\'t I get notified about a streetpass or match?',
    answer: 'Make sure Streetpass notifications are enabled in your device settings. You will only be notified if you successfully streetpass or a match someone by meeting all of each other\'s filters or liking each other.',
    tags: 'wasnt notifications not alert getting working streetpassed someone push enabled settings',
  },
  {
    question: 'What is Genius Assistant?',
    answer: 'Genius Assistant is a matchmaking AI that helps you automatically match with the right people. Genius Assistant also trains on your profile and conversations to mimic your personality and automatically chat with your matches to setup dates and hangouts based on your compatibility.',
    tags: 'what how does the ai works',
  },
  {
    question: 'What is Automatch?',
    answer: 'Automatch lets you automatically match with people you streetpass when they meet all your filters. This can be enabled and disabled under Streetpass settings.',
    tags: 'how does the auto match ai',
  },
  {
    question: 'What is Autochat?',
    answer: 'Autochat uses Genius Assistant to mimic your personality, chat with your matches, and help setup dates or hangouts — all automatically.',
    tags: 'how does the auto chat ai',
  },
  {
    question: 'Is Streetpass free?',
    answer: 'Yes! Streetpass is free to use. We don\'t believe in locking core features behind paywalls. Your ability to match and chat with others is completely free and unrestricted.',
    tags: 'how much can does it cost pay purchase',
  },
  {
    question: 'What is Streetpass Premium?',
    answer: 'Streetpass Premium is an optional monthly subscription service that unlocks exclusive features, removes ads, and prioritizes your profile to other users.',
    tags: 'subscribe subscription service exclusive features ads matchbombs spotpasses',
  },
  {
    question: 'What are Matchbombs?',
    answer: 'Matchbombs are an in-app purchase that allow you to instantly streetpass with compatible users in a wider proximity.',
    tags: 'how much can does it cost pay purchase',
  },
  {
    question: 'What are Spotpasses?',
    answer: 'Spotpasses are an in-app purchase that allows you to set a geotag at a given location for 24 hours. When set, you will streetpass with everyone who passes your spotpass location.',
    tags: 'how much can does it cost pay purchase',
  },
  {
    question: 'How can I protect my privacy?',
    answer: 'Streetpass has built-in features to protect your identity and keep you safe. Find the privacy page under settings to learn how to protect your personal details, hide your profile from people you don\'t want to be seen by, and setup Safe Zones to automatically disable streetpassing when you\'re at home, work, or school.',
    tags: 'data what if someone is tries trying uses it this for to private stalker stalking safety personal information profile home work school zones hide block',
  },
  {
    question: 'Can I control who sees my profile?',
    answer: 'Yes, you can restrict visibility based on gender, age, personal details, or even block entire areas with Safe Zones. You can also hide your profile from others until you\'ve liked them first under privacy settings.',
    tags: 'private privacy who can view data personal safety zones hide block',
  },
  {
    question: 'What are Safe Zones?',
    answer: 'Safe zones are custom areas you can setup at home, school, or work where streetpassing is automatically disabled to protect your privacy.',
    tags: 'how who does can see if my information home school work hide private privacy',
  },
  {
    question: 'Can I delete my data or account?',
    answer: 'Yes, you can delete your profile and all your account data at any time under settings. Your profile data will be retained for 3 months so that your purchases can be restored incase you decide to sign up again within that period.',
    tags: 'delete profile app does streetpass keep',
  },
  {
    question: 'Can I pause Streetpass without deleting my account or the app?',
    answer: 'Yes! You can disable streetpassing temporarily in settings. Your profile stays intact and you can chat with your current matches, but you won\'t appear to new people or receive new matches.',
    tags: 'disable delete stop matching turn off temporary temporarily break quit',
  },
  {
    question: 'How does Streetpass handle spam or fake accounts?',
    answer: 'We use device signals and behavioral patterns to detect fake or spam accounts. Users can also report and block any suspicious profiles.',
    tags: 'is scams bots fakes block report security safety',
  },
]

interface IFaqsBlockProps {
  masterRef?: any,
  order: number,
}
function FaqsBlock({ order, }: IFaqsBlockProps) {
  const systemStore = useSelector((state: IStores) => state.systemStore)
  const { mobile, } = systemStore
  const { Colors, Fonts, Spacing, } = systemStore.mobile ? systemStore.Mobile : systemStore.Desktop

  const [searchFaqs, setSearchFaqs] = useState<string>('')
  const faqsFiltered = !searchFaqs
  ? faqs : faqs.filter(faq => {
    const queryWords = searchFaqs.toLowerCase().replace(/[^\w\s]|_/g, '').split(/\s+/)
    const combined = `${faq.question} ${faq.tags}`.toLowerCase().replace(/[^\w\s]|_/g, '')
    return queryWords.every(word => combined.includes(word))
  })

  return (
    <>
      <Block order={order} style={{paddingHorizontal: Spacing.padding, paddingVertical: Spacing.paddingMd, backgroundColor: 'rgba(23,25,30, 1)',}}>
        <View style={{marginBottom: Spacing.paddingMd,}}>
          <Input
            value={searchFaqs}
            placeholder={'Ask a question...'}
            onChange={(value) => setSearchFaqs(value)}
          />
        </View>

        <View style={{borderWidth: 3, borderColor: Colors.white, borderRadius: 24, paddingHorizontal: Spacing.paddingMd,}}>
          <ScrollView style={{flex: 1,}}>
            <View style={{height: Spacing.paddingMd,}} />

            {faqsFiltered?.length ? faqsFiltered.map(({ question, answer, }, i) => {
              return (
                <View key={i} style={{marginBottom: 16, paddingBottom: 8, borderBottomWidth: i + 1 === faqsFiltered.length ? 0 : 1, borderColor: Colors.safeLightBackground,}}>
                  <Text style={{fontSize: Fonts.lg, fontWeight: Fonts.middleWeight, color: Colors.white,}}>{question}</Text>
                  <Text style={{fontSize: Fonts.md, fontWeight: Fonts.featherWeight, color: Colors.safeLighter, marginTop: 8, marginBottom: 16,}}>{answer}</Text>
                </View>
              )
            }) : <View style={{paddingBottom: mobile ? 0 : 16,}}>
              <Text style={{fontSize: Fonts.lg, fontWeight: Fonts.middleWeight, color: Colors.white,}}>No FAQs found {`:(`}</Text>
              <Text style={{fontSize: Fonts.md, fontWeight: Fonts.featherWeight, color: Colors.safeLighter, marginTop: 8, marginBottom: 16,}}>Try again.</Text>
            </View>}
          </ScrollView>
        </View>

        <View style={{marginTop: Spacing.paddingMd,}}>
          <View style={{marginBottom: 16, paddingBottom: 8, borderBottomWidth: 1, borderColor: Colors.safeLightBackground,}}>
            <Text style={{fontSize: Fonts.xl, fontWeight: Fonts.welterWeight, color: Colors.white,}}>Didn't find the answer to your question?</Text>
          </View>

          <View style={{flexDirection: 'row', justifyContent: 'center', alignItems: 'center',}}>
            <View style={{flex: mobile ? 2 : 1,}}>
              <Button
                title={'Send'}
                onPress={() => Linking.openURL(`mailto:${email}`)}
              />
            </View>

            <View style={{flex: mobile ? 3 : 5, marginLeft: 16,}}>
              <Text style={{fontSize: Fonts.lg, fontWeight: Fonts.welterWeight, color: Colors.white,}}>us an email. We'll get back to you ASAP.</Text>
            </View>
          </View>
        </View>

        <View style={{height: Spacing.padding * 4,}} />
      </Block>
    </>
  )
}

export default FaqsBlock
